<div id="modal_transparent">
  <div id="circle">
    <mat-icon>priority_high</mat-icon>
  </div>
  <div class="modal">
    <mat-dialog-content>
      <p class="d-flex justify-content-center">{{data}}</p>
      <p class="d-flex justify-content-center">{{errorText}}</p>
    </mat-dialog-content>
    <div class="justify-content-center">
      <mat-dialog-actions class="justify-content-center">
        <button  class="justify-content-center" id="yes_button" mcButton variant="closedialog" mat-dialog-close>Chiudi</button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
